<h1 *ngIf="!data.param"mat-dialog-title>Are you sure you want to redeem {{data.points}} points</h1>
<h1 *ngIf="data.param" mat-dialog-title>Are you sure you want to send SMS</h1>
<div mat-dialog-content class="text-center">
    <button mat-raised-button color="primary" (click)="closePop(true, data.param)">Yes</button>
    <button mat-stroked-button color="secondary" (click)="closePop(false, data.param)" cdkFocusInitial class="ml-10">No</button>
    <button mat-raised-button class="ml-10" style="background:#5bb921;" *ngIf="data.param === true" color="primary" (click)="closePop('Whatsapp')">
     <img src="../../../../../assets/icons/whatsapp.png" style="width: 2vw;" alt=""></button>
</div>
